// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"191":"8b4b76a4","224":"ea9f4767","350":"ecbce237","428":"c610b028","834":"302a6cf9","916":"51140882"}[chunkId] + ".css";
};